
import React, { useState } from "react";
import { sendContactMessage } from "../api/contactService";
import { sleep } from "../utils/sleep";

const ContactForm = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({ loading: false, success: null, error: null });

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Frontend Validation
    if (!formData.name.trim() || !formData.email.trim() || !formData.subject.trim() || !formData.message.trim()) {
      setStatus({ loading: false, success: null, error: "All fields are required." });
      return;
    }

    if (!validateEmail(formData.email)) {
      setStatus({ loading: false, success: null, error: "Please enter a valid email address." });
      return;
    }

    setStatus({ loading: true, success: null, error: null });
    // simulate network delay (3 sec)
    await sleep(3000);
    const response = await sendContactMessage(formData);

    if (response.success) {
      setStatus({ loading: false, success: "Your message has been sent successfully!", error: null });
      setFormData({ name: "", email: "", subject: "", message: "" });
    } else {
      setStatus({ loading: false, success: null, error: response.error || "Failed to send message." });
    }
  };

  
  return (
      <div className="p-4 rounded-4 shadow-lg">
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          className="custom-form-control form-control mb-4"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          className="custom-form-control form-control mb-4"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="subject"
          className="custom-form-control form-control mb-4"
          placeholder="Subject"
          value={formData.subject}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          className="custom-form-control form-control mb-4"
          placeholder="Your Message"
          rows="5"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>

        <button
          type="submit"
          className="btn btn-modern w-100 py-2"
          disabled={status.loading}
        >
          {status.loading ? "Sending..." : "Send Message"}
        </button>
      </form>

      {/* Success / Error messages */}
      {status.success && <p className="text-success mt-3">{status.success}</p>}
      {status.error && <p className="text-danger mt-3">{status.error}</p>}
    </div>
  );
};

export default ContactForm;
